import { AccountAddressPutSchema } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import { Field, Formik } from "formik";
import React from "react";
import { Container, Divider, Form, Header } from "semantic-ui-react";

type AddressFormProps = {
  account: Account;
  updateAddress: Function;
};

function AddressForm({ account, updateAddress }: AddressFormProps) {
  return (
    <Container textAlign="left">
      <Header as="h3">Account Address</Header>
      <Divider />
      <Formik
        initialValues={account}
        validationSchema={AccountAddressPutSchema}
        onSubmit={(values, actions) => {
          updateAddress(values);
        }}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <Field
              name="address.line1"
              label="Building Name / Number"
              component={CallableInput}
            />

            <Field
              name="address.line2"
              label="Street"
              component={CallableInput}
            />

            <Field
              name="address.level2"
              label="City"
              component={CallableInput}
            />

            <Field
              name="address.level1"
              label="County"
              component={CallableInput}
            />

            <Field
              name="address.postalCode"
              label="Postcode"
              component={CallableInput}
            />

            <Field
              name="address.country"
              label="Country"
              component={CallableInput}
            />

            <FormSubmit name="Update Account" errors={props.errors} />
          </Form>
        )}
      </Formik>
    </Container>
  );
}

export default AddressForm;
